import { FSBrand, mapFSBrand } from "../Brand";
import { FSColor, mapFSColor } from "../Color";
import { FSLocation, mapFSLocation } from "../Location";
import { FSAccessoryName, mapFSAccessoryName } from "./AccessoryName";
import { FSAccessorySubName, mapFSAccessorySubName } from "./AccessorySubName";
import { FSFileList, mapFSFileLists } from "../FileList";

/* **************************************************** Finishing Shedule Paint Accessory Data */
export interface FSPaintAccessoryData {
    id: number;
    fs_data_id: number;
    accessory_name_id: number;
    accessory_sub_name_id: number;
    number: number;
    reference: string | null;
    link: string | null;
    image_path: string | null;
    file_list: FSFileList[];
    accessory: FSAccessoryName | null;
    accessory_sub: FSAccessorySubName | null;
}

export const mapFSPaintAccessoryData = (data: any): FSPaintAccessoryData => {
    if (!data) {
        throw new Error("Invalid Data");
    }

    const res: FSPaintAccessoryData = {
        id: data.id,
        fs_data_id: data.fs_data_id,
        accessory_name_id: data.accessory_name_id,
        accessory_sub_name_id: data.accessory_sub_name_id,
        number: data.number,
        reference: data.reference || null,
        link: data.link || null,
        image_path: data.image_path || null,
        file_list: Array.isArray(data.file_list) ? mapFSFileLists(data.file_list) : [],
        accessory: data.accessory ? mapFSAccessoryName(data.accessory) : null,
        accessory_sub: data.accessory_sub ? mapFSAccessorySubName(data.accessory_sub) : null,
    };

    return res;
};

export const mapFSPaintAccessoryDatas = (data: any[]): FSPaintAccessoryData[] => {
    if (!Array.isArray(data)) {
        throw new Error("Invalid Data");
    }

    return data.map(mapFSPaintAccessoryData);
};

/* **************************************************** Finishing Shedule Paint Data */
export interface FSPaintData {
    id: number;
    fs_data_id: number;
    type: string | null;
    location_id: number | null;
    brand_id: number | null;
    color_id: number | null;
    color_code: string | null;
    link: string | null;
    image_path: string | null;
    file_list: FSFileList[];
    location: FSLocation | null;
    brand: FSBrand | null;
    color: FSColor | null;
}

export const mapFSPaintData = (data: any): FSPaintData => {
    if (!data) {
        throw new Error("Invalid Data");
    }

    const res: FSPaintData = {
        id: data.id,
        fs_data_id: data.fs_data_id,
        type: data.type || null,
        location_id: data.location_id || null,
        brand_id: data.brand_id || null,
        color_id: data.color_id || null,
        color_code: data.color_code || null,
        link: data.link || null,
        image_path: data.image_path || null,
        file_list: Array.isArray(data.file_list) ? mapFSFileLists(data.file_list) : [],
        location: data.location ? mapFSLocation(data.location) : null,
        brand: data.brand ? mapFSBrand(data.brand) : null,
        color: data.color ? mapFSColor(data.color) : null,
    };

    return res;
};

export const mapFSPaintDatas = (data: any[]): FSPaintData[] => {
    if (!Array.isArray(data)) {
        throw new Error("Invalid Data");
    }

    return data.map(mapFSPaintData);
};


/* **************************************************** Finishing Shedule Paint */
export interface FSPaint {
    id: number;
    fs_feature_id: number;
    category: string;
    location_name: string | null;
    location_id: number | null;
    data_paint: FSPaintData[];
    data_paint_accessory: FSPaintAccessoryData[];
}

export const mapFSPaint = (data: any): FSPaint => {
    if (!data) {
        throw new Error("Invalid Data");
    }

    const res: FSPaint = {
        id: data.id,
        fs_feature_id: data.fs_feature_id,
        category: data.category,
        location_name: data.location_name || null,
        location_id: data.location_id || null,
        data_paint: Array.isArray(data.data_paint) ? mapFSPaintDatas(data.data_paint) : [],
        data_paint_accessory: Array.isArray(data.data_paint_accessory) ? mapFSPaintAccessoryDatas(data.data_paint_accessory) : [],
    };

    return res;
};

export const mapFSPaints = (data: any[]): FSPaint[] => {
    if (!Array.isArray(data)) {
        throw new Error("Invalid Data");
    }

    return data.map(mapFSPaint);
};
